import React from 'react';

const Mantenimiento = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      textAlign: 'center'
    },
    icon: {
      fontSize: '80px',
      marginBottom: '20px'
    },
    title: {
      color: '#ffffff',
      fontSize: '2.5rem',
      marginBottom: '15px',
      fontWeight: 'bold'
    },
    subtitle: {
      color: '#ffffff',
      fontSize: '1.2rem',
      marginBottom: '30px',
      opacity: '0.9',
      maxWidth: '500px'
    },
    loginButton: {
      padding: '15px 40px',
      fontSize: '1rem',
      backgroundColor: '#ffffff',
      color: '#667eea',
      border: 'none',
      borderRadius: '30px',
      cursor: 'pointer',
      fontWeight: 'bold',
      textDecoration: 'none',
      transition: 'transform 0.2s, box-shadow 0.2s'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.icon}>🚧</div>
      <h1 style={styles.title}>Sitio en Construcción</h1>
      <p style={styles.subtitle}>
        Estamos trabajando para mejorar tu experiencia.
        Pronto estaremos de vuelta con novedades.
      </p>
      <a href="/login" style={styles.loginButton}>
        Acceder al Panel
      </a>
    </div>
  );
};

export default Mantenimiento;
